/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * One zero-filled calendar day, in the requested timezone. Values are
 * credits *used* (positive), already net of refunds.
 */
export interface CreditAnalyticsDay {
  date: string;
  contact_reveal?: number;
  export?: number;
  ats_sync?: number;
}
